import Insured from '@/modules/common/common/models/APP/Insured'
import LifeInsuredMedicalQuestionnaire from './LifeInsuredMedicalQuestionnaire'
import LifeBeneficiary from './LifeBeneficiary'
import LifeMortgageClause from './LifeMortgageClause'

export default class LifeHiringInsured extends Insured {
  profession: string
  activity: string
  // policyHolderBeneficiaryConsent: null
  questionnaire: LifeInsuredMedicalQuestionnaire
  beneficiaries: any[]
  mortgageClauses: any[]
  availableToSave: boolean

  constructor(data: Partial<LifeHiringInsured> = {}) {
    super(data)

    this.profession = String(data?.profession ?? '')
    this.activity = String(data?.activity ?? '')
    // this.policyHolderBeneficiaryConsent = data.policyHolderBeneficiaryConsent ?? null
    this.additionalCoverages = data.additionalCoverages ?? []
    this.questionnaire = new LifeInsuredMedicalQuestionnaire(data?.questionnaire)
    this.beneficiaries = data.beneficiaries?.map((b) => new LifeBeneficiary(b)) ?? []
    this.mortgageClauses = data.mortgageClauses?.map((m) => new LifeMortgageClause(m)) ?? []

    this.availableToSave = data.availableToSave ?? false
  }
}
